import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import CloseIcon from "@material-ui/icons/Close";
import { IconButton, LinearProgress, makeStyles } from "@material-ui/core";
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

import { resolveMediaUrl } from "../../helpers/resolveMediaUrl";



const useStyles = makeStyles({
		mainContainer: {
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				position: "fixed",
				top: "50%",
				left: "50%",
				transform: "translate(-50%,-50%)",
				width: "100vw",
				height: "100vh",
				background: "#000000e8",
				zIndex: 9999,
				flexDirection: "column",
				gap: 5,
		},
		closeButton: {
				position: "fixed",
				right: 40,
				top: 20,
				zIndex: 9999,
				color: "white",
				cursor: "pointer",
				scale: "1.5",
		}
});


export function Status({ ticket, handleStatus, timeOfStatus, relatedTickets }) {

		const videoRef = useRef(null);
		const [progress, setProgress] = useState(0);
		const [duration, setDuration] = useState(0);
		const [currentIndex, setCurrentIndex] = useState(0);
		const classes = useStyles();

		const items = relatedTickets?.length
			? relatedTickets
			: ticket
				? [ticket]
				: [];

		const currentItem = items[currentIndex];

		useEffect(() => {
				setProgress(0);
				setDuration(0);
		}, [currentIndex]);

		useEffect(() => {
				if (!currentItem?.lastMessageObj) return;

				const mediaType = currentItem.lastMessageObj.mediaType;
				const video = videoRef.current;

				if (mediaType === "video" && video) {
						const handleLoadedMetadata = () => {
								const dur = video.duration;
								const durMs = dur * 1000;
								setDuration(durMs);
								timeOfStatus(dur);
						};
						video.addEventListener("loadedmetadata", handleLoadedMetadata);
						return () =>
								video.removeEventListener("loadedmetadata", handleLoadedMetadata);
				}

				if (mediaType === "image") {
						const dur = 5;
						const durMs = dur * 1000;
						setDuration(durMs);
						timeOfStatus(dur);
				}
		}, [currentItem]);

		useEffect(() => {
				if (!duration) return;

				let start = Date.now();

				const interval = setInterval(() => {
						const elapsed = Date.now() - start;
						const percent = Math.min((elapsed / duration) * 100, 100);
						setProgress(percent);

						if (elapsed >= duration) {
								clearInterval(interval);
								handleNext();
						}
				}, 50);

				return () => clearInterval(interval);
		}, [duration, currentIndex]);

		const handleNext = () => {
				if (currentIndex < items.length - 1) {
						setCurrentIndex((prev) => prev + 1);
				} else {
						handleStatus()
				}
		};

		const handlePrev = () => {
				if (currentIndex > 0) {
						setCurrentIndex((prev) => prev - 1);
				}
		};

		if (!currentItem?.lastMessageObj?.mediaUrl) {
				return null;
		}

		const mediaSrc = resolveMediaUrl(currentItem.lastMessageObj.mediaUrl);
		const mediaType = currentItem.lastMessageObj.mediaType;

		const content = (
				<div className={classes.mainContainer}
				>
						<div style={{ display: "flex", gap: 4, width: 400 }}>
								{items.map((_, idx) => (
										<LinearProgress
												key={idx}
												variant="determinate"
												value={
														idx < currentIndex
																? 100
																: idx === currentIndex
																		? progress
																		: 0
												}
												color="secondary"
												style={{ flex: 1, height: 5, borderRadius: 5 }}
										/>
								))}
						</div>
						<IconButton
								onClick={handleStatus}
								className={classes.closeButton}
						>
								<CloseIcon />
						</IconButton>

						<div style={{ width: 400, height: 800, objectFit: "cover" }}>
								{mediaType === "video" && (
										<video
												ref={videoRef}
												src={mediaSrc}
												autoPlay
												width="100%"
												height="100%"
												style={{ objectFit: "contain" }}
												controls={false}
										/>
								)}
								{mediaType === "image" && (
										<img
												src={mediaSrc}
												title="Status"
												width="100%"
												height="100%"
												style={{ objectFit: "contain" }}
												alt="status"
										/>
								)}
						</div>

						{
								currentIndex > 0 &&
								<button onClick={handlePrev} disabled={currentIndex === 0} style={{ position: "fixed", left: 20, border: "none", background: "none", color: "white", scale: "2", cursor: "pointer" }}>
										<ChevronLeftIcon style={{ borderRadius: "50%", background: "#191818", }} />
								</button>
						}

						{
								currentIndex !== items.length - 1 &&
								<button
										onClick={handleNext}
										disabled={currentIndex === items.length - 1} style={{ position: "fixed", right: 20, border: "none", background: "none", color: "white", scale: "2", cursor: "pointer" }}
								>       <ChevronRightIcon style={{
										background: "#191818",
										borderRadius: "50%",
								}} />

								</button>
						}

				</div>

		);

		return createPortal(content, document.body);
}
